import React, { FunctionComponent } from 'react';
import { COLORS } from '../../utils';
import { IIconParentProps } from './index';

const textAlignCenter: FunctionComponent<IIconParentProps> = ({ className, hexFill: fill, viewBox, onClick }) => {
	const hexFill = fill || COLORS.midnight;
	return (
		<svg
			onClick={onClick}
			className={className || ''}
			width="20px"
			height="20px"
			viewBox={viewBox ? viewBox.join(' ') : '0 0 20 20'}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1 0.5C0.723858 0.5 0.5 0.723858 0.5 1C0.5 1.27614 0.723858 1.5 1 1.5H19C19.2761 1.5 19.5 1.27614 19.5 1C19.5 0.723858 19.2761 0.5 19 0.5H1ZM1 11.5C0.723858 11.5 0.5 11.7239 0.5 12C0.5 12.2761 0.723858 12.5 1 12.5H19C19.2761 12.5 19.5 12.2761 19.5 12C19.5 11.7239 19.2761 11.5 19 11.5H1ZM6.5 7C6.5 6.72386 6.72386 6.5 7 6.5H19C19.2761 6.5 19.5 6.72386 19.5 7C19.5 7.27614 19.2761 7.5 19 7.5H7C6.72386 7.5 6.5 7.27614 6.5 7ZM7 17.5C6.72386 17.5 6.5 17.7239 6.5 18C6.5 18.2761 6.72386 18.5 7 18.5H19C19.2761 18.5 19.5 18.2761 19.5 18C19.5 17.7239 19.2761 17.5 19 17.5H7Z"
				fill={hexFill}
			/>
		</svg>
	);
};

export default textAlignCenter;
